import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import {
  createGlobalStyle,
  ThemeProvider as StyledComponentsThemeProvider
} from 'styled-components';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import AppDataLoader from './components/AppDataLoader';
import AppScrollToTop from './components/AppScrollToTop';
import AuthContent from './components/AuthContent';
import PrivateContent from './components/PrivateContent';
import { ManagerExternalCVPage, OpportunityCandidateCVPage } from './components/pages';
import AuthRoute from './components/routes/AuthRoute';
import PrivateRoute from './components/routes/PrivateRoute';
import rootStore from './redux-modules';
import { defaultMuiTheme } from './themes';

const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
  }
  body {
    background-color: ${({ theme }) => theme.color.background.default};
    color: ${({ theme }) => theme.color.text.main};
    /* font-family: ${({ theme }) => theme.fontFamily}; */  
    font-family: Roboto, Helvetica Neue, Helvetica, sans-serif !important;
    overflow-y: scroll;
    line-height: 1.15;
  }
  .public-DraftEditor-content > div > div {
    padding-bottom: 1em;
  }
  * { word-break: break-word !important; }
  #root {
    background-color: ${({ theme }) => theme.color.background.surface};
    box-shadow: ${({ theme }) => theme.boxShadow.large};
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 1600px;
    min-height: 100%;
    min-width: 350px;
  }

  ::-webkit-scrollbar {
    -webkit-appearance: none;
  }

  ::-webkit-scrollbar:vertical {
    width: 12px;
  }

  ::-webkit-scrollbar:horizontal {
    height: 12px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, .20);
    border-radius: 10px;
    border: 2px solid #ffffff;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;  
    background-color: #ffffff; 
  }
`;

// @TODO remove this when the application version will be displayed inside the interface
if (typeof window !== 'undefined' && !Object.prototype.hasOwnProperty.call(window, 'version')) {
  Object.defineProperty(window, 'version', {
    configurable: true, // allow future redefinition if necessary
    get() {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', '/api/version', false); // synchronous request
      xhr.send(null);
      return {
        'front-end': import.meta.env.VITE_APP_VERSION || '0.5.0',
        'back-end': xhr.responseText
      };
    }
  });
}

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={defaultMuiTheme}>
        <StyledComponentsThemeProvider theme={defaultMuiTheme}>
          <CssBaseline />
          <Router>
            <AppScrollToTop />
            <Provider store={rootStore}>
              <GlobalStyle />
              <Routes>
                {/* Auth routes */}
                <Route path="/login/*" element={<AuthRoute element={<AuthContent />} />} />
                <Route path="/register/*" element={<AuthRoute element={<AuthContent />} />} />
                <Route
                  path="/forgot-password/*"
                  element={<AuthRoute element={<AuthContent />} />}
                />
                <Route
                  path="/reset-password/:token/*"
                  element={<AuthRoute element={<AuthContent />} />}
                />
                <Route
                  path="/create-password/:token/*"
                  element={<AuthRoute element={<AuthContent />} />}
                />

                {/* Public pages */}
                <Route path="/manager/cv/:id" element={<ManagerExternalCVPage />} />
                <Route path="/candidate/cv/:id" element={<OpportunityCandidateCVPage />} />

                {/* Protected area (fallback) */}
                <Route path="/*" element={<PrivateRoute element={<PrivateContent />} />} />
              </Routes>
            </Provider>
          </Router>
        </StyledComponentsThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
}

App.propTypes = {};

export default App;
